<template>
  <DxPopup title="Try the new Factz?"
           v-model:visible="popupVisible"
           :show-title="true"
           :show-close-button="true"
           :hide-on-outside-click="false"
           :drag-enabled="false"
           :width="440"
           height="auto"
           container=".cabinet-content-container"
           @hiding="onDismiss"
  >
    <DxPosition at="center" my="center" collision="fit"/>
    <div class="try-new-version">
      <p>
        A newer version of Factz is available, with an updated look and new features.
      </p>
      <p class="tip">
        To switch back later: click <strong>Use classic version</strong> next to your
        account menu in the top-right.
      </p>
      <div class="actions">
        <DxButton text="Not now"
                  styling-mode="outlined"
                  type="normal"
                  @click="onDismiss"
        />
        <DxButton text="Try new version"
                  type="default"
                  @click="onAccept"
        />
      </div>
    </div>
  </DxPopup>
</template>

<script setup>
  import { DxPopup, DxPosition } from "devextreme-vue/popup"
  import { DxButton } from "devextreme-vue"
  import { computed, ref } from "vue"
  import {
    declinePreferV3ForThreeDays,
    redirectToV3,
    setPreferV3,
  } from "@/js-modules/preferV3.js"

  const props = defineProps({
    visible: { type: Boolean, required: true },
  })
  const emit = defineEmits(["update:visible"])

  const accepting = ref(false)

  const popupVisible = computed({
    get: () => props.visible,
    set: (value) => emit("update:visible", value),
  })

  function onDismiss() {
    if (accepting.value) return
    declinePreferV3ForThreeDays()
    popupVisible.value = false
  }

  function onAccept() {
    accepting.value = true
    setPreferV3()
    redirectToV3()
  }
</script>

<style scoped lang="scss">
  .try-new-version {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    padding: 0.25rem 0.5rem 0.75rem;

    p {
      margin: 0;
      line-height: 1.45;
    }

    .tip {
      padding: 0.75rem 0.85rem;
      border-radius: 0.375rem;
      background: $gray-normal;
      font-size: 0.925rem;
    }

    .actions {
      display: flex;
      justify-content: flex-end;
      gap: 0.75rem;
    }
  }
</style>
